import axios from "axios";

// In production we serve frontend + backend from the same origin (saveursnormandes.fr,
// cheers-book.emergent.host, etc.). Use a relative `/api` base so the browser stays
// same-origin — this avoids CORS + cookie issues when the site is served from a
// custom domain different from the one baked at build time.
//
// Locally (yarn start at :3000), REACT_APP_BACKEND_URL is set in .env so devs hit
// the FastAPI server explicitly.
const isLocal = typeof window !== "undefined"
  && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
const BACKEND_URL = isLocal ? (process.env.REACT_APP_BACKEND_URL || "") : "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token fallback (cookies are primary, but cross-site preview can drop them)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// On 401 (expired/invalid token) — clear local credentials and bounce to login.
// Skips auth probe endpoints to avoid an infinite loop on first load.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthProbe = url.includes("/auth/me") || url.includes("/auth/login") || url.includes("/auth/register");
    if (status === 401 && !isAuthProbe && typeof window !== "undefined") {
      const hadToken = !!localStorage.getItem("access_token");
      localStorage.removeItem("access_token");
      const path = window.location.pathname;
      // Stay inside the POS surface when a tablet session expires — the
      // POSAuthGate will re-show the PIN pad instead of bouncing the
      // barman out to the customer login page.
      const isPosSurface = path.startsWith("/pos");
      if (hadToken && !isPosSurface && !path.startsWith("/connexion") && !path.startsWith("/inscription")) {
        const next = encodeURIComponent(path + window.location.search);
        window.location.replace(`/connexion?next=${next}&expired=1`);
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
